import { Skeleton } from "@/shared/ui";

export default function ReportsPageSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <div className="radius-3xl surface-base-fill p-7">
        <div className="mb-5">
          <Skeleton width={280} height={24} />
          <div className="mt-2">
            <Skeleton width={380} height={16} />
          </div>
        </div>
        <div className="space-y-2">
          {Array.from({ length: 8 }).map(function renderRow(_, i) {
            return <Skeleton key={i} className="h-12 w-full" />;
          })}
        </div>
      </div>

      <div className="radius-3xl surface-base-fill p-7">
        <div className="mb-5">
          <Skeleton width={200} height={24} />
          <div className="mt-2">
            <Skeleton width={350} height={16} />
          </div>
        </div>
        <div className="space-y-2">
          {Array.from({ length: 8 }).map(function renderRow(_, i) {
            return <Skeleton key={i} className="h-12 w-full" />;
          })}
        </div>
        <div className="flex items-center justify-between mt-4">
          <Skeleton width={200} height={20} />
          <div className="flex items-center gap-2">
            <Skeleton width={32} height={32} />
            <Skeleton width={32} height={32} />
            <Skeleton width={32} height={32} />
          </div>
        </div>
      </div>
    </div>
  );
}
